import React from "react";
import styled from "styled-components";

import { ReferencePickerPlugin } from "@adsk/acc-reference-picker";
import FilterButton from "@adsk/alloy-react-filter-button";

import { AssetWithCategoryAndStatus } from "../../models";
import AssetsPickerSearchBox from "./AssetsPickerSearchBox";

const CustomTopBarContainer = styled.div`
  display: flex;
  justify-content: end;
  padding-bottom: 16px;

  & > * {
    &:not(:first-child) {
      margin-left: 8px;
    }
  }
`;

// We add includeSubcategories as part of the filters to have access to this data in
// queryEntities function but we don't want it to be part of the filtersCount
// because includeSubcategories is part of Category filter field.
const FILTERS_TO_IGNORE = ["includeSubcategories", "includeSublocations"];

const CustomTopBar: ReferencePickerPlugin<AssetWithCategoryAndStatus>["CustomTopBar"] =
  (props) => {
    const { filtersOpen, toggleFiltersPanel, filters, setFilters } = props;
    const filtersNotIgnored =
      Object.keys(filters).filter(
        (filterKey) => !FILTERS_TO_IGNORE.includes(filterKey)
      ) || [];

    const clear = () => {
      setFilters?.({});
    };

    return (
      <CustomTopBarContainer>
        <div style={{ width: 300 }}>
          {/*
          // The searchExpression is defined as optional in ReferencePickerPlugin<AssetWithCategoryAndStatus>["CustomTopBar"]
          // but required in the ReferencePickerPlugin<AssetWithCategoryAndStatus>["CustomPickerSearchBox"]>
          // that's the reason why we explicitly pass searchExpression to AssetsPickerSearchBox
          // remove it if the definitions in @adsk/acc-reference-picker change
        */}
          <AssetsPickerSearchBox
            {...props}
            searchExpression={props.searchExpression}
          />
        </div>
        <FilterButton
          filtersOpen={filtersOpen}
          filtersCount={filtersNotIgnored.length}
          clearFilters={clear}
          onClick={toggleFiltersPanel}
        />
      </CustomTopBarContainer>
    );
  };

export default CustomTopBar;
